import { Templates } from '../../compile';
import { ListConfirmModalOptions, PagingOptions } from '../../interfaces/options';

export const DefaultListConfirmModalOptions: ListConfirmModalOptions<any> = {
	contentTemplate: Templates.modal_listConfirm,
	width: '50%',
	table: {
		dataSource: {
			paging: <PagingOptions>{
				pageSize: 10
			}
		}
	}
};
